module.exports = __webpack_public_path__ + "img/risks-cancer.2bb00e8e.svg";